import { createSelector } from '@ngrx/store';

export const getFixedTemplatesState = createSelector(
    (state: any) => state.fixedTemplates,
    (state: any) => state
);